/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable} from '@angular/core';
import { AppService } from '../api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { NgZone } from '@angular/core';
import { LocalStorageService } from './localstorage.service';

@Injectable({
  providedIn: 'root'
})
export class ProjectsService{
  project_list: any;
  isProjectLoad=false;
  selectedProject: any;
  displayProject = false;
  activeSubject: Subject<any> = new Subject<any>();
  cart_data: any;
  product_count: any;
  inLineLoader=false;
  customer_name: any;
  mobile: any;
  displaypopupAssign=false;
  assignProjectId: any;
  is_mobile_error = false;
  is_customer_name_error=false;
  isProjectAssignError=false;
  error_message: any;
  assigned_projects: any;
  isLoadingData=false;
  is_assigned: any;
  service_provider_name: any;
  customer: any;
  main_space_list:any[]=[]
  activeSCId: any;
  isdisplayTagSpaces=false;
  seleted_productList: any[] = [];
  activeProdId:any
  alreadyAdded=false;
  constructor(public _as: AppService,private zone: NgZone, private _router: Router, private _actRouter: ActivatedRoute,private ngZone:NgZone,private localStorageService: LocalStorageService) {
    if (this.localStorageService.getItem('selectedProject')) {
      this.selectedProject = JSON.parse(this.localStorageService.getItem('selectedProject')||'');
    }
    this.activeSubject.subscribe(() => {
      if (this.localStorageService.getItem('selectedProject')) {
        this.selectedProject = JSON.parse(this.localStorageService.getItem('selectedProject')||'');
      }
    });
    this._actRouter.queryParams.subscribe((pra: any) => {
      this.activeSCId = pra.subCat;
      this.activeProdId=pra.activeProdId
    });
  }

  onDisplayProjects(isPopup:any,isLogin?:any) {
    // console.log("isLogin 1111 =>",isLogin)
    if(this._router.url.split('/')[0]=='ab-project'){
      return
    }
    if(!(this._router.url.split('/')[1].split('?')[0]=='as-collection')){
      // console.log("isLogin 2222 =>",isLogin)
      this.getProjectList(isPopup,'',isLogin);
    }
  }
  closeDisplayProjects() {
    this.displayProject = false;
  }
  onSelectProject(project:any,isLogin?:any) {
    this.selectedProject = project;
    let paramsObject: any;
    if(!isLogin){
      this._actRouter.queryParamMap
      .subscribe((params) => {
        paramsObject = { ...params };
      }
      );
    this._as.loginSuccess();
    const params = paramsObject.params;
    const link = this._router.url.split('?')[0];
    const newparams = { ...params, pId: this.selectedProject.id }
    this._router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this._router.navigate([link], { queryParams: newparams }));
    }
    this.localStorageService.setItem('selectedProject', JSON.stringify(this.selectedProject));
    const user_info = JSON.parse(this.localStorageService.getItem('user_info') || "")
    user_info.directSearch.projectInfo.id=this.selectedProject.id;
    this._as.user_info=user_info;
    this.localStorageService.setItem('user_info', JSON.stringify(user_info));
    if(this._as.user_info.is_assigned){
      const redirectTo = JSON.parse(this.localStorageService.getItem('redirectTo') || '');
      this._router.navigate([redirectTo.link], { queryParams: redirectTo.queryParams });
      this.localStorageService.removeItem('redirectTo');
    }
    if(this._router.url.includes('isProductTagToSpace')){
      this.onSeletedProduct()
    }
    this.getInfoData();
    this.checkCart();
    this.closeDisplayProjects();
  }
  ondisplayProjectPopup(isLogin?:any) {
    if(!isLogin){
      let paramsObject: any;
    this._actRouter.queryParamMap
      .subscribe((params) => {
        paramsObject = { ...params };
      }
      );
    const redirectTo = {
      link: this._router.url.split('?')[0],
      queryParams: paramsObject.params
      // isProdetailPage:false
    }
    this.localStorageService.setItem('redirectTo', JSON.stringify(redirectTo));
    }
    
    this._router.navigate(['ab-project'], { queryParams: { isProjCr: true } })
    this.closeDisplayProjects();
  }
  getProjectList(isPopup:any,key?:string,isLogin?:any) {
    const url = this._as.api_base_url + `user/project/`;
    this._as.getRequest(url, true)
      .subscribe((res:any) => {
        this._as.isDisplayLogin = false;
        this.project_list = res.projects;
        this.assigned_projects = res.assigned_projects;
        //START my list compare deals and remove back to cart or save idea from live offer page
        if((key=='cart' || key=='offers') && !isPopup){
          if(!this._as.user_info.is_assigned){
            this.selectedProject=this.project_list.find((project:any)=>{return project.id==this.selectedProject.id})
          }else{
            this.selectedProject=this.assigned_projects.find((project:any)=>{return project.id==this.selectedProject.id})
          }
          if(key=='offers'){
            location.reload();
          }
          return
        }
        //END my list compare deals and remove back to cart or save idea from live offer page
        if (!this.project_list.length && !this._as.user_info.is_service_provider && !this._as.user_info.is_assigned) {
          
          this.ondisplayProjectPopup(isLogin);
          return
        }
        if (!this.project_list.length && this._as.user_info.is_service_provider) {
          this.ondisplayProjectPopup();
          return
        }

        this.isProjectLoad = true;
        if (this.project_list.length && !isPopup && !this.selectedProject) {
          // this.ondisplayProjectPopup(); 
          this.onSelectProject(this.project_list[0],isLogin)
          return
        }
        if(this._as.user_info.is_assigned && !this.project_list.length 
          && this.assigned_projects.length && !this.selectedProject){
          this.onSelectProject(this.assigned_projects[0],isLogin)
          return
        }
      
        if(isPopup){
          this.displayProject = true;
        }
      });
  }

  checkCart() {
    if (this._as.isUserLoggedIn) {
      let project_id!: number;
      if (this._as.user_info.is_service_provider) {
        if (!this.selectedProject) {
          this.onDisplayProjects(false);
          return
        }
        project_id = this.selectedProject.id;
      } else {
        try {
          project_id = this._as.user_info.directSearch.projectInfo.id
        } catch (e) { 
          // eslint-disable-next-line no-empty
        }
      }
      const form_type = "search"
      const url = this._as.api_base_url + `user/check-cart/?project=` + project_id + `&form_type=` + form_type;
      this._as.getRequest(url, true)
        .subscribe((res:any) => {
          this.cart_data = res.data;
          this.product_count = res.data.product_count
        })
    }
  }

  getProjectId() {
    let project_id!: number;
    if (this._as.user_info?.is_service_provider || this._as.user_info?.is_assigned) {
      if (!this.selectedProject) {
        this.onDisplayProjects(false);
        return ''
      }
      project_id = this.selectedProject.id;
    } else {
      try {
        const user_info = JSON.parse(this.localStorageService.getItem('user_info') || "");
        project_id = user_info.directSearch.projectInfo.id;
      } catch (e) {
        // eslint-disable-next-line no-empty
       }
    }
    return project_id
  }

  // Project Assigned
  onDisplayAssignPopup(id:number) {
    this.displaypopupAssign = true;
    this.assignProjectId = id;
  }
  closeAssignDisplay(){
    this.displaypopupAssign = false;
  }
  onAssignSubmit(){
    if(!this.mobile){
      this.is_mobile_error = true;
      return
    }
    if(!this.customer_name){
      this.is_customer_name_error = true;
      return
    }
    this.assignProject();
  }
  assignProject() {
    this.inLineLoader = true;
    const url = this._as.api_base_url + 'user/share-collection/';
    const data = {
      name: this.customer_name,
      mobile: this.mobile,
      project:this.assignProjectId
    }
    this._as.postRequest(url, data, true)
      .subscribe(() => {
        this.inLineLoader = false;
        this.getInfoData();
        this.customer_name=undefined;
      this.mobile=undefined;
      this.assignProjectId=undefined;
      let paramsObject: any;
      this._actRouter.queryParamMap
      .subscribe((params) => {
        paramsObject = { ...params };
      }
      );
    const params = paramsObject.params;
    const link = this._router.url.split('?')[0];
    const newparams = { ...params, pId: this.selectedProject.id }
    this._router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this._router.navigate([link], { queryParams: newparams }));
    // this.localStorageService.setItem('selectedProject', JSON.stringify(this.selectedProject));
        this.closeAssignDisplay();
      }, (err:any) => {
        this.inLineLoader = false;
        this.isProjectAssignError=true;
        if(this.mobile == this._as.user_info.userProfile.mobile){
          this.error_message = 'You can not assign a project to self';
        }else{
          this.error_message = err.error.error;
        }
       
        setTimeout(() => {
          this.isProjectAssignError=false;
        this.error_message=undefined;
        }, 4000);
      })
  }
  // End project assigned

  getLiveOffers(form_type?:string,sub_category?:any){
    this.isLoadingData = true;
    this._as.compareOffers =[];
    let url = this._as.api_base_url + 'user/live-offer-brands/?project='+ this.selectedProject.id+'&form_type='+form_type;
    if(form_type=='category'){
      url = this._as.api_base_url + 'user/live-offer-brands/?project='+ this.selectedProject.id+'&form_type='+form_type+'&sub_category='+sub_category;
    }

    this._as.getRequest(url, true).subscribe((res: any) => {
      if (res) {
        this._as.compareOffers = res.brands_list;
        if (this._as.compareOffers.length <= 1) {
          this.onBrandSelect(this._as.compareOffers[0]);
        } else {
          this._as.isBrandLiveOffers = true;
        }
      }
      this.isLoadingData = false;
    })
}

onBrandSelect(brand: any) {
  const url = 'live-offers';
  const queryParams = { fl: 'search', pId: this.selectedProject.id, slug_name: brand.department.slug_name, brandId: brand.brand_id }
  // this._router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
    this._router.navigate([url], { queryParams: queryParams })
    // );
  this._as.isBrandLiveOffers = false;
}
getInfoData() {
  const project = this.getProjectId();
  const form_type = 'save-idea';
  const url = this._as.api_base_url + 'user/collection-data/?project=' + project + '&form_type=' + form_type;
  this._as.getRequest(url, true)
    .subscribe((res: any) => {
      this.is_assigned = res.is_assigned;
      this.customer = res.customer_name;
      this.service_provider_name = res.service_provider_name;
    });
}


/*save idea new login flow */

addToSpace() {
  const url = this._as.api_base_url + 'search/selectspacelist/?project=' + this.selectedProject?.id + '&sub_category=' + this.activeSCId;
  this._as.getRequest(url, true)
    .subscribe((res: any) => {
      this.main_space_list = res.data;
      this.isdisplayTagSpaces=true;
    });
}

onSeletedProduct() {
  this.seleted_productList = [];
  const url = this._as.api_base_url + 'search/selectProdlist/?project=' + this.selectedProject?.id + '&sub_category=' + this.activeSCId;
  this.ngZone.run(()=>{
    this._as.getRequest(url, true)
    .subscribe((res: any) => {
      console.log('save',res)
      this.seleted_productList=res.seleted_productList;
      const is_found=this.seleted_productList.find((prod:any)=>prod.id==this.activeProdId)
      if(is_found){
        this._router.navigate([], {
          relativeTo: this._actRouter, queryParams: { isProductTagToSpace: null, activeProdId: null },
          queryParamsHandling: 'merge',
          replaceUrl:true
        });
        this.alreadyAdded=true;
        this.ngZone.run(() => {
          setTimeout(() => {
            this.alreadyAdded = false;
          }, 2000);
        });
        this._router.navigate([], { relativeTo: this._actRouter }).then(() => {
          this.refreshCurrentRoute();
        });
      }else{
        this.addToSpace();
      }
      this.checkCart()
    });
  })
}
refreshCurrentRoute() {
  const currentUrl = this._router.url;
  this._router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    this._router.navigate([currentUrl]);
  });
}

}
